import { Picture } from './picture/Picture';
import Name from './Name';
import Headline from './Headline';
import { Industry } from './Industry';
import Location from './Location';
import SideNav from './SideNav';
import ShareModal from '../ui/ShareModal';
import StarRating from './StarRating';


export {
    Picture,
    Name,
    Headline,
    Industry,
    Location,
    SideNav,
    ShareModal,
    StarRating,
}



// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/header/index.js